import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";
import { useApp } from "../../contexts/AppContext";

function useComponents() {
  const { organizationId, pageId } = useApp();

  const basePath = useMemo(() => {
    return `${organizationId}/page/${pageId}/component`;
  }, [organizationId, pageId]);

  return {
    getComponents: (payload) =>
      apiInstance.post(basePath + "/get-components", payload),
    getComponentStatusTypes: (payload) =>
      apiInstance.get(basePath + "/component-status-types", payload),
    createComponent: (payload) => apiInstance.post(basePath, payload),
    getComponent: (componentId) =>
      apiInstance.get(`${basePath}/${componentId}`),
    deleteComponent: (componentId) =>
      apiInstance.delete(`${basePath}/${componentId}`),
  };
}

export default useComponents;
